import { configureStore } from "@reduxjs/toolkit";
import userMangementSlice from "reducer/admin/userMangenmentSlice";
import projectMonitoringSlice from "reducer/admin/projectMonitoringSlice";
import postMonitoringSlice from "reducer/admin/postMonitoringSlice";
import subsciptionSlice from "reducer/admin/subscriptionSlice";
import paymentSlice from "reducer/admin/paymentSlice";
import dashboardSlice from "reducer/admin/dashboardSlice";

const adminStore = configureStore({
  reducer: {
    users: userMangementSlice,
    projects: projectMonitoringSlice,
    posts: postMonitoringSlice,
    subscriptions: subsciptionSlice,
    payments: paymentSlice,
    dashboard: dashboardSlice,
  },
});

export default adminStore;
